import { render } from "./TwLoading.vue?vue&type=template&id=7a24dd31"
const script = {}

import exportComponent from "/codebuild/output/src3176072795/src/johnson-inspection-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__